/**
 * Shared utility: alert type → staff page route mapping.
 * Used by ControlTowerPage, AlertsPanel, and NeedsAttentionPanel.
 *
 * Deterministic — every backend AlertType maps to exactly one route.
 * No substring matching, no undefined return paths.
 */

const ALERT_ROUTE_MAP: Record<string, string> = {
  // Hotel-level (pulse score) → Control Tower (system-wide, no single entity page)
  HOTEL_AT_RISK: '/control-tower',
  HOTEL_CRITICAL: '/control-tower',

  // Dimension-level (pulse dimensions)
  OPERATIONS_CRITICAL: '/control-tower',
  SERVICE_DEGRADING: '/rooms',

  // Signal-derived
  SLA_BREACH_RISK: '/requests',
  HOUSEKEEPING_OVERLOAD: '/housekeeping',
  MAINTENANCE_ESCALATION: '/requests',
  REQUEST_SURGE: '/requests',
  WORKLOAD_CRITICAL: '/housekeeping',

  // Metric-derived
  CAPACITY_STRAIN: '/rooms',
  BACKLOG_CRITICAL: '/requests',
};

export function drillRouteForAlertType(type: string): string {
  const safeType = (type ?? '').toUpperCase();
  return ALERT_ROUTE_MAP[type] ?? ALERT_ROUTE_MAP[safeType] ?? '/control-tower';
}

/**
 * UI-3: Entity drill routes — navigate from any surface to entity deep views.
 */
export function entityRoute(entityType: 'room' | 'guest' | 'request', entityId: string): string {
  switch (entityType) {
    case 'room': return `/rooms/${encodeURIComponent(entityId)}`;
    case 'guest': return `/guests/${encodeURIComponent(entityId)}`;
    case 'request': return `/requests/${encodeURIComponent(entityId)}`;
  }
}
